import { DefaultButton, Modal, PrimaryButton } from 'office-ui-fabric-react';
import { useTranslation } from 'react-i18next';

const ConfirmationPrompt = ({
  isOpen,
  onDismiss,
  onConfirm,
  text,
  disabled,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div className="global-message">
      <Modal isOpen={isOpen} onDismiss={onDismiss}>
        <div className="modal-outer">
          <div className="modal-outer-content">
            <p>{text}</p>
          </div>
          <div className="global-message-modal-button-bar">
            <DefaultButton
              text={translator('global.cancel')}
              onClick={onDismiss}
              disabled={disabled}
            />
            <PrimaryButton
              text={translator('global.confirm')}
              onClick={onConfirm}
              disabled={disabled}
            />
          </div>
        </div>
      </Modal>
    </div>
  );
};

export { ConfirmationPrompt };
